export const HEALTH_CHECK_KEY_BASE = 'health-check';
export const HealthCheckKeyFactory = {
    healthCheck: () => [HEALTH_CHECK_KEY_BASE],
};
